<template>

    <div class="overflowed-button" :class="[ isBackground ? 'overflowed-button--bg-pattern' : 'overflowed-button--normal' ]" @click="goToLink(link)">
        <div class="overflowed-button__border"></div>
        <div class="ob-image-container">
            <img :src="require('@/assets/img/link_img/' + image + '')" alt="">
            <img class="saving-promise-img" v-if="image === 'faturaniyukleel.png'" :src="require('@/assets/img/link_img/ts-3-x-copy@3x.png')">
        </div>
        <div class="ob-title-container">
        <p class="ob__title" v-html="title" />
            
        </div>
        <p class="ob-text-container" v-html="text" />
        
        
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "ButtonWithImage",
        data() {
            return {
                imageLocation: ''
            }
        },
        props: ['text', 'image', 'link', 'isBackground', 'title'],
        methods: {
            goToLink(value) {
                if (value === '#') {
                    EventBus.$emit('menu-status');
                    this.$router.push({name: 'Home'});
                } else if (value == "to:Documentary25Litre") {
                    
                    window.top.location.href = "https://www.yarininsuyu.com/25-litre";
                }else if (value.includes('to:')) {
                    
                    this.$router.push({name: value.replace('to:', '')});
                } else if (value.includes('link:')) {
                    
                    window.top.location.href = value.replace('link:', '');
                } else if (value === 'waterPrintStart') {
                    /*EventBus.$emit('water-print-status');*/
                    window.top.location.href = "https://www.yarininsuyu.com/su-ayak-izini-hesapla";
                    dataLayer.push({ event: "promiseButton_startPromiseQuiz", page: window.location.pathname == '/' ? 'homepage' : window.location.pathname.replace('/','') })
                } else if (value === "_fn") {
                    this['callback']();
                } else if (!value) {
                    return false;
                } else {
                    window.open(value);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ob-title-container {
        position: absolute;
        width: 100%;
    }
    .ob-title-container .ob__title {
        width: calc(100% - 85px);
        margin-left: auto;
        top: 43px;
        white-space: nowrap;
        text-transform: none;
        font-weight: normal;
        height: auto !important;
        margin: 0 0 0 auto;
        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            width: calc(100% - 150px);
            top: 65px;
        }
    }
    
    .overflowed-button {
        height: 160px;
        min-height: 160px;
        width: 332px;
        position: relative;
        display: flex;
        margin: 0px 40px;
        overflow: hidden;

        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            width: 80%;
            height: 300px;
            min-height: 300px;
            margin: auto;
            overflow: visible;
        }

        &:hover {
            & > .overflowed-button__border::after {
                width: 100%;
                border-radius: 50px;
            }

            & > p {
                color: black;
            }

            cursor: pointer;
        }

        &--bg-pattern {
            & > .overflowed-button__border {
                background-image: url('../assets/img/link_img/bg-pattern@3x.png');
                background-size: cover;
            }

            &:hover {
                & > p {
                    color: black;
                }
                .ob-image-container > img {
                    filter: brightness(0);
                }
            }
        }

        .overflowed-button__border {
            content: "";
            width: 330px;
            height: 99px;
            position: absolute;
            border: 1px solid white;
            border-radius: 50px;
            bottom: 0;
            cursor: pointer;
            z-index: 1;
            overflow: hidden;

            @media (min-device-width: 320px) and (max-device-width: 768px) {
                margin: 0px;
                width: 100%;
                height: 190px;
                border-radius: 100px;
                border: 2px solid white;
            }

            &:after {
                content: "";
                width: 0px;
                height: 99px;
                position: absolute;
                background-color: white;
                border-radius: 50px;
                bottom: 0;
                cursor: pointer;
                z-index: 1;
                transition: width 0.5s;
                margin-bottom: -1px;

                @media (min-device-width: 320px) and (max-device-width: 768px) {
                    height: 190px;
                    border-radius: 100px !important;
                }

            }
        }

        .ob-text-container {
            position: relative;
            height: 100px;
            width: calc(100% - 150px);
            display: flex;
            align-items: center;
            text-transform: uppercase;
            font-size: 12px;
            z-index: 2;
            font-weight: bold;
            padding-right: 30px;
            margin: auto 0 0 0;
            top: initial;
        }

        .ob-image-container {
            border-radius: 0 0 0 48px;
            display: flex;
            padding: 0 0 0 10px;
            z-index: 2;
            overflow: hidden;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                width: 300px;
                overflow: visible;
            }

            img {
                width: 150px;
                position: relative;
                z-index: 1;
                margin-left: auto;
                cursor: pointer;
                object-fit: contain;

                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    width: 300px;
                    border-radius: 0 0 0 83.7px;
                    object-fit: cover;
                }

                &[src*='faturaniyukleel'] {
                    left: -15px;
                }


                &.saving-promise-img {
                    object-fit: contain;
                    width: 48px;
                    height: 67px;
                    margin: auto;
                    position: absolute;
                    bottom: 15px;
                    left: 100px;
                    @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                        height: 117px;
                        bottom: 15px;
                        left: 150px;
                        border-radius: initial;
                        width: 105px;
                    }
                }
            }
        }

        p {
            position: relative;
            top: 48px;
            height: 100px;
            width: calc(100% - 150px);
            display: flex;
            align-items: center;
            text-transform: uppercase;
            font-size: 12px;
            z-index: 2;
            font-weight: bold;
                padding-right: 30px;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                height: 190px !important;
                font-size: 30px !important;
            }
        }
    }
</style>
